<template>
  <section id="section__complete" class="view-container">
    <div class="width-100">
      <v-row no-gutters class="mt-10 mb-10">
        <v-col cols="12">
          <p class="font--p-3">
            <template v-if="referralCode">
              {{ platformName }} 서비스 <br />
              이용 준비가 끝났어요!
            </template>
            <template v-else>
              {{ platformName }} 서비스 <br />
              서비스 시작을 <br />
              기다려주세요!
            </template>
          </p>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-10 mb-10">
        <v-col cols="12">
          <img src="@/assets/images/apply/clap.png" class="clap" />
        </v-col>
      </v-row>

      <template v-if="loansRequest">
        <BasicButton
          class="button mb-3"
          depressed
          height="48"
          :to="{ path: `/woori-crowd/${loansRequest.uuid}` }"
        >
          우리동네 크라우드 서류제출하기
        </BasicButton>
      </template>

      <template v-if="referralCode">
        <v-row no-gutters>
          <v-col cols="12" class="text-left pb-12">
            <p class="mb-1 font--m-5 font-weight-bold">
              *새로 개설된 경남은행 계좌로 카드사 입금계좌 변경(제신고)이 완료되면 바로 서비스가
              개시됩니다.
            </p>
            <p class="mb-1 font--m-5 font-weight-bold">
              *제신고 완료까지는 영업일 기준 평균 2~3일이 소요됩니다.
            </p>
            <p class="font--m-5 font-weight-bold">
              담당 추천인이나 영업사원이 있다면 상의해 주세요.
            </p>
          </v-col>
        </v-row>
      </template>
    </div>
  </section>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      loansRequest: null,
    }
  },
  computed: {
    ...mapState('contract', { contractCurrent: 'current' }),
    ...mapState('auth', ['me']),
    ...mapGetters('auth', ['referralCode']),
    ...mapGetters('myfinbiz', ['platformName']),
  },
  methods: {
    ...mapActions('loansRequest', {
      storeGetRequests: 'getRequests',
    }),
  },
  watch: {
    contractCurrent: {
      immediate: true,
      deep: true,
      handler(v) {
        const { status } = v
        if (status === 'started') {
          this.$router.replace('/')
        }
      },
    },
    me: {
      deep: true,
      immediate: true,
      async handler() {
        const type = 'woori_crowd'
        if (this.me?.acquisitionRoute) {
          const { data } = await this.storeGetRequests({ type })
          if (data.length > 0) {
            this.loansRequest = data[0]
          }
        }
      },
    },
  },
}
</script>
<style lang="scss" scoped>
#section__complete {
  text-align: center;

  .clap {
    width: 100%;
    height: 210px;
    object-fit: contain;
  }
}
</style>
